import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.holidayTable],
        config: {
            headerName: getLocalizedString("tableType"),
            field: "type",
            isObligatory: true,
            isSelect: true,
        }
    },
    {
        pages: [paths.holidayTable],
        config: {
            headerName: getLocalizedString("seniorityInYears"),
            field: "seniorityFrom",
            isNumeric: true,
            isObligatory: true,
            dataType: "number",
            maxLength: 9,
            minLength: 1,
        }
    },
    {
        pages: [paths.holidayTable],
        config: {
            headerName: getLocalizedString("seniorityTo"),
            field: "seniorityTo",
            isNumeric: true,
            isObligatory: true,
            dataType: "number",
            maxLength: 9,
            minLength: 1,
        }
    },
    {
        pages: [paths.holidayTable],
        config: {
            headerName: getLocalizedString("entitlementDays"),
            field: "lawDays",
            isNumeric: true,
            isObligatory: true,
            dataType: "number",
            maxLength: 5,
            minLength: 1,
        }
    },
    {
        pages: [paths.holidayTable],
        config: {
            headerName: getLocalizedString("additionalOrProgressiveDays"),
            field: "additionalDays",
            isNumeric: true,
            isObligatory: true,
            dataType: "number",
            maxLength: 5,
            minLength: 1,
        }
    },
]